export const toSearchParams = (
  params: Record<string, string | string[] | undefined>,
) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (!v) return;
    if (Array.isArray(v)) {
      v.forEach((vv) => {
        query.append(k, vv);
      });
    } else {
      query.append(k, v);
    }
  });
  return query;
};
